export default "__VITE_ASSET__BRv0LaTO__"